<p-toast></p-toast>
<app-consent-form></app-consent-form>
<div class="card" *ngIf="isActionSectionEnabled">
    <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                class="p-button-success"></button> -->
            <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
        </ng-template>
        <ng-template pTemplate="right">
            <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status" class="mr-3"></p-dropdown>
            <textarea id="description" [(ngModel)]="remarks" placeholder="{{'REMARKS'| translate}}" pInputTextarea required rows="3" cols="20" class="mr-3"></textarea>
            <button pButton pRipple label="{{'SUBMIT'| translate}}" (click)="handleClick()"
                class="p-button-help"></button>
        </ng-template>
    </p-toolbar>
</div>